export function calculateAdjustedPrice(
  originalPrice: string,
  profitMarginPercent: number
): string {
  // Parse original price
  const price = parseFloat(originalPrice);

  // Handle invalid price
  if (isNaN(price)) {
    return originalPrice;
  }

  // Calculate multiplier (20 → 1.20, -20 → 0.80, 0 → 1.00)
  const multiplier = 1 + profitMarginPercent / 100;

  // Calculate adjusted price
  const adjustedPrice = price * multiplier;

  // Handle negative prices (return $0.00)
  if (adjustedPrice < 0) {
    return '0.00';
  }

  // Format to 2 decimal places
  return adjustedPrice.toFixed(2);
}

export function formatPrice(price: string | number): string {
  // Handle empty, null, or undefined input
  if (!price && price !== 0) {
    return '';
  }

  // Convert string to number
  const numericPrice = typeof price === 'string' ? parseFloat(price) : price;

  // Handle invalid numeric conversion
  if (isNaN(numericPrice)) {
    return '';
  }

  // Use Intl.NumberFormat for US locale currency formatting
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(numericPrice);
}
